import axios from 'axios'
import { BASE_URL } from './url_config'
import { log } from './useLog'

// Get dashboard configuration for current user
export const getDashboardConfig = async (token) => {
  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const url = BASE_URL + '/home/get_dashboard_config_api'
    const result = await axios.get(url, { headers })
    return result.data
  } catch (err) {
    log("Error in getDashboardConfig:", err)
    return { error: true, message: "Error fetching dashboard config" }
  }
}

// Get all available sections (for admin)
export const getDashboardSections = async (token) => {
  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const url = BASE_URL + '/home/get_dashboard_sections_api'
    const result = await axios.get(url, { headers })
    return result.data
  } catch (err) {
    log("Error in getDashboardSections:", err)
    return { error: true, message: "Error fetching dashboard sections" }
  }
}

// Get all template types (for admin)
export const getDashboardTemplateTypes = async (token) => {
  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const url = BASE_URL + '/home/get_dashboard_template_types_api'
    const result = await axios.get(url, { headers })
    return result.data
  } catch (err) {
    log("Error in getDashboardTemplateTypes:", err)
    return { error: true, message: "Error fetching template types" }
  }
}

// Create a new template type
export const createDashboardTemplateType = async (token, name, description) => {
  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const url = BASE_URL + '/home/create_dashboard_template_type_api'
    const result = await axios.post(url, { name, description }, { headers })
    return result.data
  } catch (err) {
    log("Error in createDashboardTemplateType:", err)
    return { error: true, message: "Error creating template type" }
  }
}

// Update a template type
export const updateDashboardTemplateType = async (token, id, name, description) => {
  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const url = BASE_URL + '/home/update_dashboard_template_type_api'
    const result = await axios.put(url, { id, name, description }, { headers })
    return result.data
  } catch (err) {
    log("Error in updateDashboardTemplateType:", err)
    return { error: true, message: "Error updating template type" }
  }
}

// Update sections for a template
export const updateDashboardTemplateSections = async (token, templateId, sections) => {
  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const url = BASE_URL + '/home/update_dashboard_template_sections_api'
    const result = await axios.post(url, { template_id: templateId, sections }, { headers })
    return result.data
  } catch (err) {
    log("Error in updateDashboardTemplateSections:", err)
    return { error: true, message: "Error updating template sections" }
  }
}

// Delete a template type
export const deleteDashboardTemplateType = async (token, id) => {
  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const url = BASE_URL + '/home/delete_dashboard_template_type_api'
    const result = await axios.delete(url, { headers, data: { id } })
    return result.data
  } catch (err) {
    log("Error in deleteDashboardTemplateType:", err)
    return { error: true, message: "Error deleting template type" }
  }
}

// Set a template as default
export const setDefaultDashboardTemplate = async (token, id) => {
  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const url = BASE_URL + '/home/set_default_dashboard_template_api'
    const result = await axios.post(url, { id }, { headers })
    return result.data
  } catch (err) {
    log("Error in setDefaultDashboardTemplate:", err)
    return { error: true, message: "Error setting default template" }
  }
}

// Assign a template to a client
export const assignDashboardTemplateToClient = async (token, clientId, templateId) => {
  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const url = BASE_URL + '/home/assign_dashboard_template_to_client_api'
    const result = await axios.post(url, { client_id: clientId, template_id: templateId }, { headers })
    return result.data
  } catch (err) {
    log("Error in assignDashboardTemplateToClient:", err)
    return { error: true, message: "Error assigning template to client" }
  }
}
